/** @file Hook: calls `onClose` on a pointer press outside the element, on window blur and on resize. */
import { useEffect, type RefObject } from 'react';

/** Listens while mounted; a press inside `ref` (including a right-click on the menu) does not dismiss. */
export function useMenuDismiss(ref: RefObject<HTMLElement | null>, onClose: () => void): void {
  useEffect(() => {
    const onDown = (e: PointerEvent): void => {
      if (!(e.target instanceof Node) || !ref.current?.contains(e.target)) onClose();
    };
    const close = (): void => { onClose(); };
    document.addEventListener('pointerdown', onDown, true);
    window.addEventListener('blur', close);
    window.addEventListener('resize', close);
    return () => {
      document.removeEventListener('pointerdown', onDown, true);
      window.removeEventListener('blur', close);
      window.removeEventListener('resize', close);
    };
  }, [ref, onClose]);
}
